import {CounterType} from "../../../../../gd-modules/dashboard/widgets/constants/types";
import {ReportDate} from "../../../../../fields3/system/agile/report-date/model/model";
import formatDaterange from "../../../../../gd/format/daterange";
import {TickType} from "../../../../../gd/utils/datetime/interval";


export default class ReportProjectsVelocity_Settings {

    public projectIds         : ID[] | null
    public reportDate         : ReportDate

    public counterType        : CounterType
    public tickType           : TickType
    public showAverage        : boolean

    constructor(data: any) {
        this.projectIds       = _.get(data, "projectIds", [])
        this.reportDate       = !!data?.reportDate ? new ReportDate(data.reportDate) : new ReportDate({lastDays: 14})
        this.counterType      = _.get(data, "counterType",  CounterType.TASKS_TOTAL)
        this.tickType         = _.get(data, "tickType",     TickType.DAY)
        this.showAverage      = _.get(data, "showAverage", true)
    }

    get reportTitle() {

        const dateRange = this.reportDate.startEnd

        return formatDaterange(dateRange)
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            projectIds       : this.projectIds,
            reportDate       : this.reportDate.toJSON(),
            counterType      : this.counterType,
            tickType         : this.tickType,
            showAverage      : this.showAverage,
        }

        return result
    }
}
